var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirebase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.8 24.6.17-.237 8.02-15.214.017-.161-3.535-6.64a.656.656 0 0 0 -1.227.207z",
    fill: "#ffc24a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5.9 24.42.128-.25 7.937-15.056-3.526-6.666a.6.6 0 0 0 -1.133.206z",
    fill: "#ffa712"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16.584 14.01 2.632-2.7-2.633-5.021a.678.678 0 0 0 -1.195 0l-1.407 2.682v.229z",
    fill: "#f4bd62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m16.537 13.9 2.559-2.62-2.559-4.88a.589.589 0 0 0 -1.074-.047l-1.414 2.729-.042.139z",
    fill: "#ffa50e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m5.802 24.601.077-.078.279-.113 10.26-10.222.13-.354-2.559-4.878z",
    fill: "#f6820c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m16.912 29.756 9.288-5.179-2.654-16.331a.635.635 0 0 0 -1.075-.346l-16.671 16.7 9.233 5.155a1.927 1.927 0 0 0 1.878 0",
    fill: "#fde068"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m26.115 24.534-2.632-16.208a.557.557 0 0 0 -.967-.353l-16.616 16.596 9.131 5.1a1.912 1.912 0 0 0 1.863 0z",
    fill: "#fcca3f"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m16.912 29.6a1.927 1.927 0 0 1 -1.878 0l-9.158-5.078-.076.078 9.233 5.155a1.927 1.927 0 0 0 1.878 0l9.289-5.178-.023-.14z",
    fill: "#eeab37"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.d770ed71d4d33ffa60f8cae9b7ba0350.svg";
export { ForwardRef as ReactComponent };